import React from "react";
import "./circleLoader.css";
function CircleLoader() {
	return (
		<div className="Wrapper">
			<div className="loader"></div>
		</div>
	);
}

export default CircleLoader;
